import { put, takeLatest, all } from 'redux-saga/effects'
import { onAddErrorNotification, onAddInfoNotification } from '@tabeeb/modules/notification/actions'

import * as aiActions from '../actions'

function* onPublishSuccess() {
  yield put(onAddInfoNotification({ message: 'The model has been published successfully.' }))
}

function* onPublishFailed() {
  yield put(onAddErrorNotification({ message: 'Failed to publish the model.' }))
}

function* onUnpublishSuccess() {
  yield put(onAddInfoNotification({ message: 'The model has been unpublished successfully.' }))
}

function* onUnpublishFailed() {
  yield put(onAddErrorNotification({ message: 'Failed to unpublish the model.' }))
}

function* publish() {
  yield all([
    takeLatest(aiActions.publishAiModel.success, onPublishSuccess),
    takeLatest(aiActions.publishAiModel.failed, onPublishFailed),
    takeLatest(aiActions.unpublishAiModel.success, onUnpublishSuccess),
    takeLatest(aiActions.unpublishAiModel.failed, onUnpublishFailed),
  ])
}

export default publish
